import System from './system';
import { GameSvc } from '../services/game.service';
import compact from 'lodash/compact';
import { factorial } from '../utilities/factorial'
import { PaytableSvc } from '../services/paytable.service';
import { BettingSvc } from '../services/betting.service';

class Bet {
  constructor(data) {
    this.b = BettingSvc.getBettingSvc();
    this.g = GameSvc.getGameSvc();

    this.numbers = [];
    this.numbersLen = 0;
  }

  /**
   * Create final bet
   * @returns {Object}
   */
  finalizeBet() {
    let finalizedBet;
    this.numbers = compact(this.b.ticket.input);
    this.numbersLen = this.numbers.length;

    if (this.b.type === 'normal' && (this.numbers.length > this.g.spotNumber && this.numbers.length <= this.b.maxSystemNumber)) {
      this.setSystemBet();
    }

    this.b.clientId = this.clientId;
    this.b.betType = this.betType;

    switch (this.b.type) {
      case 'normal':
        finalizedBet = this.resolveNormalBet();
        break;
      case 'system':
        finalizedBet = this.resolveSystemBet();
        break;
      case 'special':
        finalizedBet = this.resolveSpecialBet();
        break;
      default:
        finalizedBet = this.resolveNormalBet();
    }

    finalizedBet[0].displayBetType = 'Keno';
    finalizedBet[0].eventId = this.b.eventId;
    finalizedBet[0].numEvents = parseInt(this.b.numEvents, 10);
    finalizedBet[0].id = this.b.specialBetType || this.numbersLen;
    finalizedBet[0].betType = this.numbersLen;

    // Between 30-39 are special odds which will be handled bellow
    if (finalizedBet[0].id < 30 || finalizedBet[0].id > 39) {
      finalizedBet[0].displayValue = this.numbers.sort((a, b) => a - b).join(', ');
      finalizedBet[0].value = this.numbers;
    }

    return finalizedBet;
  }

  resolveSpecialBet() {
    let finalBet = {};
    let actions = {};

    finalBet.displayName = this.b.name;

    if (this.b.specialBetType !== 40 && this.b.specialBetType !== 41) {
      let choice = this.b.ticket.input || this.b.choiceClicked;

      for (let i in this.b.specialBets) {
        if (this.b.specialBets[i].id === this.b.specialBetType) {
          actions = this.b.specialBets[i].actions;
        }
      }

      finalBet.displayValue = actions[choice - 1].info.split(' - ')[1];
      finalBet.value = this.b.ticket.input - 1;
      finalBet.odds = sevenConfig.data.config.betOdds[this.b.specialBetType].value[finalBet.value] ||
                      sevenConfig.data.config.betOdds[this.b.specialBetType].value;
    } else {
      finalBet.odds = sevenConfig.data.config.betOdds[this.b.specialBetType].value[this.b.ticket.input.length - 1];
    }

    finalBet.system = false;
    finalBet.type = this.b.specialBetType;
    finalBet.shortcut = this.b.shortcut;

    return [finalBet];
  }

  /**
   * Resolve normal bet
   * @returns {Array}
   * @private
   */
  resolveNormalBet() {
    if (this.notInPaytable(this.numbersLen)) {
      return null;
    }

    return [{
      displayName: 'Spot ' + this.numbersLen,
      odds: null,
      system: false,
      type: null
    }];
  }

  /**
   * Resolve system bet
   * @returns {Array}
   * @private
   */
  resolveSystemBet() {
    if (this.notInPaytable(Number(this.b.system))) {
      return null;
    }

    let system = new System(this.b.system, this.numbersLen);

    return [{
      displayName: 'System ' + system.title,
      combinations: factorial(this.numbersLen) / (factorial(this.b.system) * factorial(this.numbersLen - this.b.system)),
      system: Number(this.b.system),
      odds: null,
      type: null
    }];
  }

  /**
   * Set system type and value
   * @private
   */
  setSystemBet() {
    let paytable = PaytableSvc.getPaytableSvc().paytable;
    let system = Object.keys(paytable)[0].split('_');

    this.b.type = 'system';
    this.b.system = system[0];
  }

  notInPaytable(what) {
    return PaytableSvc.getPaytableSvc().paytable[what + '_' + this.numbersLen] === undefined;
  }
}

export default Bet;



// WEBPACK FOOTER //
// bet.js